






























import { Component, Prop, Vue } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbInput, mdbAlert } from '@folky-tools/mdbvue';
import EditAddress from '@/components/shared/EditAddress.vue';
import { required } from 'vuelidate/lib/validators';
import { Company } from '@/models/companies/company';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbInput,
        mdbAlert,
        EditAddress
    },
    validations: {
        company: {
            taxCode: { required }
        }
    }
})
export default class CompanyData extends Vue {
    @Prop(Company) private company!: Company;

    private hasErrors(): boolean {
        this.$v.company.$touch();
        if (this.$v.company.$error) {
            return true;
        }
        return false;
    }
}
